import { Observable } from 'rxjs';
import {
  Product
} from '../domain';

export abstract class ProductPortalRepository {
  abstract getProducts(): Observable<Product[]>;
}
